import React, { FC } from 'react'
import { Button } from '@wmgtech/legato'

import { IFilterButtonGroupProps } from './FilterButtonGroup.props'

import styles from './FilterButtonGroup.module.scss'

export const FilterButtonGroup: FC<IFilterButtonGroupProps> = ({ currentValue, optionList, onToggle }) => (
  <div className={styles.btnGroup}>
    {
      optionList.map((option) => (
        <Button
          key={option.value}
          label={option.label}
          colorType="secondary-black"
          size="sm"
          onClick={() => onToggle(option.value)}
          {...(option.value !== currentValue && { containerStyle: 'outline' })}
        />
      ))
    }
  </div>
)
